import React, { FC, useCallback, useEffect, useRef } from "react";

import { useIntl } from "react-intl";

import File from "@mapmycustomers/shared/types/File";
import { stopEvents } from "@mapmycustomers/shared/util/browser";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import FileTagSelector from "../FileTagSelector";

import styles from "./AddTagButton.module.scss";

export interface AddTagButtonProps {
  onChange: (tags: File["tags"]) => void;
  tags: File["tags"];
}

const AddTagButton: FC<AddTagButtonProps> = ({ onChange, tags = [] }) => {
  const intl = useIntl();
  const ref = useRef<HTMLDivElement>(null);
  const [tagsSelectorVisible, showTagsSelector, hideTagsSelector] = useBoolean(false);

  const handleClickOutside = useCallback(
    (event) => {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        !event.target.closest(".ant-dropdown")
      ) {
        hideTagsSelector();
      }
    },
    [hideTagsSelector]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [handleClickOutside]);

  return (
    <div onClick={stopEvents} ref={ref}>
      {tagsSelectorVisible ? (
        <FileTagSelector onChange={onChange} value={tags} />
      ) : (
        <div className={styles.container} onClick={showTagsSelector}>
          {intl.formatMessage({
            id: "component.addTag.button.title",
            defaultMessage: "+ Add Tag",
            description: "Add Tag button",
          })}
        </div>
      )}
    </div>
  );
};

export default AddTagButton;
